import { render, staticRenderFns } from "./OrgCourseDetail.vue?vue&type=template&id=8676378e&scoped=true"
import script from "./OrgCourseDetail.vue?vue&type=script&lang=js"
export * from "./OrgCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./OrgCourseDetail.vue?vue&type=style&index=0&id=8676378e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8676378e",
  null
  
)

export default component.exports